import { motion } from "framer-motion";
import { ACTIVATION_URL } from "@/lib/links";
import { PostIntakeSteps } from "./PostIntakeSteps";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.95, ease: [0.22, 1, 0.36, 1] } },
};

/**
 * Primary + secondary hero CTAs. Anchor tags (not <Link>) so react-snap
 * prerendering emits crawlable static links.
 */
export default function HeroActions() {
  return (
    <motion.div
      initial="hidden"
      animate="show"
      variants={fadeUp}
      transition={{ delay: 0.3 }}
      className="mt-7 flex flex-wrap items-center gap-4"
    >
      <a
        data-testid="hero-start-analysis"
        href={ACTIVATION_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="iw-btn-red inline-flex items-center gap-2 px-8 py-4 text-[0.72rem]"
      >
        Start Your Optimization Analysis <span aria-hidden>→</span>
      </a>
      <a
        data-testid="hero-explore-medical-care"
        href="/medical-care"
        className="iw-btn-ghost inline-flex items-center gap-2 px-7 py-4 text-[0.72rem]"
      >
        Explore Medical Care <span aria-hidden>→</span>
      </a>
      <PostIntakeSteps testId="hero-post-intake-steps" className="basis-full mt-1" />
    </motion.div>
  );
}
